import { get, handleError } from '@/helpers/http';

export function refreshChamps() {
    return get(`/champs/refresh`);
}

export { handleError };
